module.exports = __webpack_public_path__ + "img/hardware1.018a7b6c.png";